// extracted by mini-css-extract-plugin
export default {"button":"SidebarButton_button__m0S5I","transparent":"SidebarButton_transparent__X4tuO","white":"SidebarButton_white__RF0yb","active":"SidebarButton_active__kpp6G"};